import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { SectorWatchModel } from './SectorWatch.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { ExchangeComponent } from '../../../gotx/components/Exchange/Exchange.component';
import { GotxGridComponent } from '../../../gotx/components/gotx-grid/gotx-grid.component';

const customCss: string = '';

@Component({
  selector: 'app-SectorWatch',
  templateUrl: './SectorWatch.component.html'
})
export class SectorWatchComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('btnRefresh', { static: false }) btnRefresh: ButtonComponent;
  @ViewChild('SectorWatchGrid', { static: false }) SectorWatchGrid: GotxGridComponent;
  skeletonContentLoaded = false;

  displayTitle = false;   //To Hide the Title of the screen

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmExchange.revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock) {
    super(services);
    this.value = new SectorWatchModel();
    this.componentCode = 'SectorWatch';
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmExchange.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.cstmExchange.cmbExchange.setFocus(true);
    this.setDependencies();
  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'SectorWatch';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmExchange_desc'] = this.cstmExchange.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmExchange = this.cstmExchange.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmExchange.setValue(inputValue['cstmExchange'], inputDesc['cstmExchange_desc']);
    this.value = new SectorWatchModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'SectorWatch'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'SectorWatch_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('SectorWatch_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmExchange = this.cstmExchange.getFieldValue();
      this.cstmExchange.valueChangeUpdates().subscribe((value) => { this.value.cstmExchange = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
      this.btnSubmit_click();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmExchange.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmExchange.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new SectorWatchModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  fieldDependencies = {
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }
  datafields = [
    { name: 'id', type: 'string' },
    { name: 'name', type: 'string' },
    { name: 'index', type: 'number' },
    { name: 'netChange', type: 'number' },
    { name: 'percentageChange', type: 'number' },
    { name: 'previousClose', type: 'number' },
    { name: 'turnOver', type: 'number' },
    { name: 'volume', type: 'number' },
    { name: 'trade', type: 'number' },
  ];

  rowId = "name";
  datatype = "json";
  respObj: any;
  data = [];

  columns: any[] = [
    // { text: this.transalte('SectorWatchGrid.SectorId'), datafield: 'name', width: "11%", cellsalign: 'left', align: 'center' },
    { text: this.transalte('SectorWatchGrid.SectorName'), datafield: 'id', cellsalign: 'left', align: 'center' },
    { text: this.transalte('SectorWatchGrid.Value'), datafield: 'index', width: "11%", cellsalign: 'right', cellsformat: 'f2', align: 'center' },
    { text: this.transalte('SectorWatchGrid.NetChange'), datafield: 'netChange', width: "11%", cellsalign: 'right', cellsformat: 'f2', align: 'center' },
    { text: this.transalte('SectorWatchGrid.Change'), datafield: 'percentageChange', width: "11%", cellsalign: 'right', cellsformat: 'f2', align: 'center' },
    { text: this.transalte('SectorWatchGrid.PrevClose'), datafield: 'previousClose', width: "11%", cellsalign: 'right', cellsformat: 'f2', align: 'center' },
    { text: this.transalte('SectorWatchGrid.TurnOver'), datafield: 'turnOver', width: "11%", cellsalign: 'right', cellsformat: 'f2', align: 'center' },
    { text: this.transalte('SectorWatchGrid.Volume'), datafield: 'volume', width: "11%", cellsalign: 'right', cellsformat: 'n', align: 'center' },
    { text: this.transalte('SectorWatchGrid.NoofTrades'), datafield: 'trade', width: "12%", cellsalign: 'right', cellsformat: 'n', align: 'center' },
  ];

  async btnSubmit_click() {

    // let res ={  "respCode": "0",  "errMsg": "",  "response": [    {      "id": "BANK",      "name": "BANK",      "index": "38000.0",      "netChange": "-583.39",      "previousClose": "0.00",      "percentageChange": "0.0",      "upDown": "",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "CASPI",      "name": "CASPI",      "index": "13433.0",      "netChange": "-941.71",      "previousClose": "0.00",      "percentageChange": "-6.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "CERAMIC",      "name": "CERAMIC",      "index": "445.0",      "netChange": "-109.03",      "previousClose": "0.00",      "percentageChange": "-19.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "CSCX",      "name": "CSCX",      "index": "8444.0",      "netChange": "-308.65",      "previousClose": "0.00",      "percentageChange": "-3.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "CSE30",      "name": "CSE30",      "index": "12351.0",      "netChange": "-724.02",      "previousClose": "0.00",      "percentageChange": "-5.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "ENERGY",      "name": "ENERGY",      "index": "9743.0",      "netChange": "-236.12",      "previousClose": "0.00",      "percentageChange": "-2.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    },    {      "id": "ICT",      "name": "ICT",      "index": "7161.0",      "netChange": "-583.62",      "previousClose": "0.00",      "percentageChange": "-7.0",      "upDown": "D",      "turnOver": "-0.01",      "volume": "0",      "trade": "0"    }  ],  "sessionResponse": null,  "target": null};
    // this.SectorWatchGrid.reloadGrid(res['response']);

    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    document.getElementById('errMsgDiv').innerHTML = "";

    if (errorCount == 0) {
      inputMap.clear();

      this.services.http.fetchApi('/market/sectorwatch', 'POST', inputMap).subscribe(

        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          //console.log("Intial Responsee",res['response']);
          var productSelected = this.services.dataStore.getproductMasterData();
          
           //removes the item whose product doesnot matches with the selected product
           res['response'] = res['response'].filter(item => item.product === productSelected);

          //console.log("Final equal Responsee",res['response']);
          if (respCode != null && respCode == 0) {
            //this.services.alert.showAlert(2, "Failure", -1);
            this.SectorWatchGrid.reloadGrid(res['response']);
          }
          else {
            //this.services.alert.showAlert(1, "Sucess", 2000);
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
            //this.services.alert.showAlert(2, err['ErrorDescription'], -1);
          }
          document.getElementById('errMsgDiv').innerHTML = "System is Down please try again";

        }
      );
    }

  }

  async btnExport_click() {
    if (this.SectorWatchGrid.gotxGrid.getrows().length <= 0) {
      this.services.alert.showAlert(2, "There is No Data to export", -1);
    } else {
      //this.SectorWatchGrid.gotxGrid.exportdata('csv', "Sector_Watch");
      const rows = this.SectorWatchGrid.gotxGrid.getrows();
   const columns = this.SectorWatchGrid.gotxGrid.attrColumns;
   this.services.dataStore.exportGridFunction(rows,columns,"Sector_Watch");
    }
  }
}
